import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Check, ArrowRight, Home } from 'lucide-react';
import { subscriptionService } from '../services/api';
import './SubscriptionSuccess.css';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    // Simulate verification process
    const timer = setTimeout(async () => {
      try {
        if (sessionId) {
          await subscriptionService.confirmSubscription(sessionId);
        }
        subscriptionService.setSubscriptionTier('pro');
      } catch (err) {
        console.error('Failed to confirm subscription', err);
      }
      setIsVerifying(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [sessionId]);

  const handleContinueToDashboard = () => {
    navigate('/home');
  };

  const handleGoToSettings = () => {
    navigate('/settings', { state: { activeTab: 'subscription' } });
  };

  if (isVerifying) {
    return (
      <div className="subscription-success-container">
        <div className="subscription-success-card verifying">
          <div className="verification-spinner"></div>
          <h2>Verifying your subscription...</h2>
          <p>Please wait while we confirm your payment.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-success-container">
      <div className="subscription-success-card">
        <div className="success-icon">
          <Check size={64} />
        </div>
        
        <h1>Welcome to Brainy AI Pro!</h1>
        <p className="success-message">
          Your subscription has been activated successfully. You now have access to all Pro features including unlimited AI lessons, unlimited chat, and advanced analytics.
        </p>

        <div className="pro-features-highlight">
          <h3>What's unlocked for you:</h3>
          <ul>
            <li><Check size={16} /> Unlimited AI-Generated Lessons</li>
            <li><Check size={16} /> Unlimited AI Chat Queries</li>
            <li><Check size={16} /> Advanced Learning Analytics</li>
            <li><Check size={16} /> Priority Customer Support</li>
            <li><Check size={16} /> Custom Learning Paths</li>
            <li><Check size={16} /> Knowledge Graph Access</li>
          </ul>
        </div>

        <div className="success-actions">
          <button 
            onClick={handleContinueToDashboard}
            className="primary-action-btn cta-signup-btn"
          >
            <Home size={18} />
            Continue to Dashboard
            <ArrowRight size={18} />
          </button>
          
          <button 
            onClick={handleGoToSettings}
            className="secondary-action-btn"
          >
            Manage Subscription
          </button>
        </div>

        <div className="subscription-details">
          <p>
            Your subscription will automatically renew monthly. You can manage your subscription or cancel anytime in your account settings.
          </p>
          {sessionId && (
            <p className="session-info">
              Session ID: <code>{sessionId}</code>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess; 